module.exports = __webpack_public_path__ + "static/europe_flags.06d16ac1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/subdomen/europe_flags.svg
// module id = 907
// module chunks = 35783957827783